import React, { useState } from "react";
import "./CandidateFormModal.css";
import { updateSubscription, createSubscription } from "../../api/adminSubscriptionApi";
const ManageSubscriptionModal = ({ mode, subscription, onClose, onSuccess }) => {
  console.log("🟣 [ManageModal] received subscription:", subscription);

  const [form, setForm] = useState({
    role: subscription?.role || "",
    applicationsPerDay: subscription?.applicationsPerDay || "",
    endDateCst: "" // 👈 optional, CREATE only
  });

  const handleSubmit = async () => {
    try {
      if (mode === "CREATE") {
        const payload = {
          role: form.role,
          applicationsPerDay: Number(form.applicationsPerDay)
        };

        if (form.endDateCst) {
          payload.endDateCst = form.endDateCst;
        }

        await createSubscription(subscription.candidateId, payload);


      } else {
        await updateSubscription(subscription.id, {
          role: form.role,
          applicationsPerDay: Number(form.applicationsPerDay)
        });
      }

      onSuccess();
      onClose();
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        "Failed to save subscription";
      alert(msg);
    }
  };


  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>
          {mode === "CREATE" ? "Create Subscription" : "Manage Subscription"}
        </h2>

        <div className="form-group">
          <label>Role</label>
          <input
            value={form.role}
            onChange={e => setForm({ ...form, role: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Applications / Day</label>
          <input
            type="number"
            value={form.applicationsPerDay}
            onChange={e =>
              setForm({ ...form, applicationsPerDay: e.target.value })
            }
          />
        </div>

        {mode === "CREATE" && (
          <div className="form-group">
            <label>End Date (Optional)</label>
            <input
              type="datetime-local"
              value={form.endDateCst}
              onChange={e =>
                setForm({ ...form, endDateCst: e.target.value })
              }
            />
          </div>
        )}


        {mode === "EDIT" && (
          <>
            <div className="form-group">
              <label>Status</label>
              <div>{subscription.expired ? "Expired" : "Active"}</div>
            </div>

            <div className="form-group">
              <label>Current End Date</label>
              <div>
                {new Date(subscription.endDateCst).toLocaleDateString()}
              </div>
            </div>
          </>
        )}


        <div className="modal-actions">
          <button className="secondary" onClick={onClose}>Cancel</button>
          <button onClick={handleSubmit}>Save Changes</button>
        </div>
      </div>
    </div>
  );
};
export default ManageSubscriptionModal;